import plugin from './install.ts'

// --- Plugin installer
export default plugin

// --- Dynamic Component Loader

export { default as DonationsLoader } from './DonationsLoader.vue'
